import { Link, useLocation } from 'react-router-dom';
import { useState, useEffect } from 'react';

const NutrareHeader = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const isActive = (path: string) => location.pathname === path;

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled
          ? 'bg-white shadow-lg'
          : 'bg-gradient-to-r from-orange-500 to-amber-500'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <Link to="/nutrare" className="flex items-center">
            <img
              src="https://static.readdy.ai/image/3b71a02bb86d4e011a6e698798aa6f47/ac435f6d5b1a7055bcf07f711dd158e1.png"
              alt="Nutrare"
              className="h-16 w-auto"
            />
          </Link>

          {/* Navigation */}
          <nav className="hidden md:flex items-center gap-8">
            <Link
              to="/"
              className={`font-semibold transition-colors whitespace-nowrap cursor-pointer ${
                isScrolled
                  ? 'text-gray-700 hover:text-orange-600'
                  : 'text-white hover:text-amber-100'
              }`}
            >
              Início
            </Link>
            <Link
              to="/nutrare"
              className={`font-semibold transition-colors whitespace-nowrap cursor-pointer ${
                isScrolled
                  ? isActive('/nutrare')
                    ? 'text-orange-600'
                    : 'text-gray-700 hover:text-orange-600'
                  : 'text-white hover:text-amber-100'
              }`}
            >
              Produtos
            </Link>
            <Link
              to="/about"
              className={`font-semibold transition-colors whitespace-nowrap cursor-pointer ${
                isScrolled
                  ? 'text-gray-700 hover:text-orange-600'
                  : 'text-white hover:text-amber-100'
              }`}
            >
              Sobre Nós
            </Link>
            <a
              href="https://wa.me/5519998928137"
              target="_blank"
              rel="noopener noreferrer"
              className={`px-6 py-3 rounded-full font-semibold transition-all whitespace-nowrap cursor-pointer ${
                isScrolled
                  ? 'bg-gradient-to-r from-orange-500 to-amber-500 text-white hover:shadow-lg'
                  : 'bg-white text-orange-600 hover:bg-amber-50'
              }`}
            >
              <i className="ri-whatsapp-line mr-2"></i>
              Contato
            </a>
          </nav>

          {/* Mobile Menu Button */}
          <button
            className={`md:hidden w-10 h-10 flex items-center justify-center cursor-pointer ${
              isScrolled ? 'text-gray-700' : 'text-white'
            }`}
          >
            <i className="ri-menu-line text-2xl"></i>
          </button>
        </div>
      </div>
    </header>
  );
};

export default NutrareHeader;
